import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import store from "./app/store";
import { Provider } from "react-redux";
import logo from './logo.svg';

import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

const i18n = require('react-redux-i18n').I18n;
const Loader = () => (
  <div className="App">
    <img src={logo} className="App-logo" alt={i18n.t("loader")} />
    <div>{i18n.t("loader")}</div>
  </div>
);

ReactDOM.render(
  <Suspense fallback={<Loader />}>
    <Provider store={store}>
      <App />
    </Provider>
  </Suspense>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
